import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  type?: 'default' | 'liquidGlass' | undefined;
}

export const MainGnbMenuBar = styled.div<IProps>`
  position: relative;
  background-color: #fff;
  overflow: hidden;

  .swiper {
    padding: 8px 14px;
    height: 43px;

    .swiper-slide {
      margin: 0 1px;
    }
  }

  .area-click {
    height: 27px;
  }

  .active .area-click {
    color: #000 !important;
  }

  ${props => {
    switch (props.type) {
      case 'default':
        return css`
          /* .area-click {
            border: 1px solid #eee;
          } */
        `;

      case 'liquidGlass':
        return css`
          background-color: transparent;

          .menubar-swiper {
            background-color: transparent;
          }

          .area-click {
            /* color: #fff;
            background: rgba(226, 226, 226, 0.2);
            box-shadow: inset 1px 0.5px 0.5px -0.5px rgba(255, 255, 255, 0.9),
              inset -1px -0.5px 0.5px -0.5px rgba(255, 255, 255, 0.9),
              0 4px 6px 0 rgba(0, 0, 0, 0.05);
            backdrop-filter: blur(2px); */
          }

          .active .area-click {
            /* background-color: #fff; */
            color: #fff !important;
            /* box-shadow: none; */
          }
        `;
      default:
        break;
    }

    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .swiper {
      padding: ${mixin.pxToVw('8 14')};
      height: ${mixin.pxToVw('43')};

      .swiper-slide {
        margin: ${mixin.pxToVw('0 1')};
      }
    }

    .area-click {
      height: ${mixin.pxToVw('27')};
    }
  }
`;
